import { render, staticRenderFns } from "./itemCard.vue?vue&type=template&id=534a0f4a&scoped=true&"
import script from "./itemCard.vue?vue&type=script&lang=js&"
export * from "./itemCard.vue?vue&type=script&lang=js&"
import style0 from "./itemCard.vue?vue&type=style&index=0&id=534a0f4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a0f4a",
  null
  
)

export default component.exports